import 'apps/hiring/styles/components/add-behavior-modal.scss';
import React from 'react';
import withData from 'util/hoc/with-data';
import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';

class AddGroupModal extends React.Component {
  state = {
    adding: false
  }

  mapGroups = ({name, id}) => (
    <div className="edit-target-attribute" key={id}>
      <span className="edit-target-attribute-name">{name}</span>
      <span className="flex-spacer" />
      <button className="button-noborder-tertiary" onClick={()=>!this.state.adding&&this.handleAdd(id)} disabled={this.state.adding}>ADD</button>
    </div>
  )

  handleAdd = async (val) => {
    this.setState({ adding: true });
    await this.props.add(val);
    this.setState({ adding: false });
  }

  render() {
    const {
      graph_data,
      graph_loading,
    } = this.props;

    return (
      <div className="hiring-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <p>Choose Group</p>
            <a onClick={this.props.onClose} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body">
          {
            graph_loading
              ? (
                <h4>Loading</h4>
              )
              : null
          }
          { resolve(graph_data, 'organization/groups/children', []).map(this.mapGroups) }
        </div>
        <div className="hiring-modal-footer">
        </div>
      </div>
    );
  }
}


AddGroupModal.propTypes = {
  graph_data: PropTypes.obect,
  graph_loading: PropTypes.bool,
  exclude: PropTypes.array,
  currentUsers: PropTypes.array,
  onClose: PropTypes.func,
  add: PropTypes.func
};

AddGroupModal.query = async () => (
  HiringQuery(`
    {
      organization {
        groups
      }
  }
`)
);

export default withData(AddGroupModal);
